import { ThemeConsumer } from "styled-components";
import axios, { getResponseError } from "../services/axiosRequest";
export const create = (params) => {
  axios
    .post(`suggestions/`, params)
    .then((element) => (document.location.href = "/suggestions"))
    .catch(getResponseError);
};
